module.exports = __webpack_public_path__ + "files/c197b51774f8a758a3aa57685d95a845.png";